import styled from 'styled-components';
import { Box, Button } from '@rsos/base-components';
import { ButtonProps } from '@rsos/components/capstone/base/Button';

interface ListButtonInterface extends ButtonProps {
  isSelected: boolean;
}

export const CloseButton = styled(Button).attrs({
  btnType: 'invisible',
  noMargin: true,
})`
  padding: 0;
  &:hover {
    background-color: transparent;
  }
`;

export const ListButton = styled(Button).attrs<ListButtonInterface>({
  btnType: 'invisible',
  noMargin: true,
})<ListButtonInterface>`
  height: auto;
  text-align: left;
  padding: 8px 16px;
  flex-shrink: 0;
  justify-content: start;
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.highlights : 'transparent'};

  border-radius: 0px;

  &:focus {
    box-shadow: none;
  }
`;

export const SearchInput = styled.input`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.secondaryText};
  border: none;
  font-size: 14px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.secondaryText};
  }
  &:focus {
    outline: none;
  }
`;

export const Titles = styled(Box).attrs({
  border: '1px solid',
  borderColor: 'lightLineDivider',
  borderRadius: '5px',
  height: '100%',
  marginTop: '8px',
})`
  overflow-y: auto;
`;

export const SearchBar = styled(Box).attrs({
  horizontal: true,
  padding: '10px',
  border: '1px solid',
  borderColor: 'lightLineDivider',
  borderRadius: '5px',
  align: 'center',
  gridColumnGap: '10px',
})``;

export const MessageDisplay = styled(Box).attrs({
  flex: '1',
  border: '1px solid',
  borderColor: 'lightLineDivider',
  borderRadius: '5px',
  padding: '8px',
})``;

export const SampleMessage = styled(Box).attrs({
  marginTop: '16px',
  backgroundColor: 'primaryBase',
  padding: '8px',
  borderRadius: '5px',
})``;
